<div class="text-right">
  <button class="btn btn-light hover-button back" (click)="backClick()">
    <mat-icon>keyboard_backspace</mat-icon>&nbsp; Back To Fleet View
  </button>
</div>
<div class="graph">
  <div class="chart-title">
    <span class="info" >
      Performance Against CP
      <mat-icon class="info" matTooltip="Bar chart represents performance of each segment based on  lost or gained values of Time and Bunker(sum of all fuels)">info</mat-icon>
    </span>
  </div>
  <div #barChartContainer [chart]="barChart"></div>
</div>
